import axios from "axios";
import { Message } from "element-ui";
//axios.defaults.baseURL = "/hk/api/api_sc_lusc.asp"; //本地
// axios.defaults.baseURL = "/api/api_vue.asp";//正式

export const request = axios.create({
	// baseURL: "/hk/api/api_sc_lusc.asp", //本地
	baseURL: "/api/api_order.asp", //正式
});
export const requestphp = axios.create({
	baseURL: "/api/php/api.php",
});
//客户自定义的api文件
export const requestzdy = axios.create({
	// baseURL: "/hk/api/api_xfy.asp", //本地
	baseURL: "/api/api_xfy.asp", //正式
});
//ocr
export const requestocr = axios.create({
	baseURL: "/api/ocr1.php", //本地识别行驶证地址
});
//php图片上传
export const requestphptp = axios.create({
	baseURL: "/api/upload.php", //php图片上传
});
//微信消息提醒
export const requestwx = axios.create({
	baseURL: "http://hkqp.hkrj.net/api/send_wx.php", //微信消息提醒
});
// 网络不通时候的提示;
request.interceptors.response.use(
	(response) => {
		return response;
	},
	(error) => {
		Message({
			message: "请检查网络连接",
			type: "error",
			duration: 5 * 1000,
			showClose: true,
		});
		return Promise.reject(error);
	}
);

// 网络不通时候的提示;本地识别行驶证地址
requestocr.interceptors.response.use(
	(response) => {
		return response;
	},
	(error) => {
		Message({
			message: "请检查网络连接",
			type: "error",
			duration: 5 * 1000,
			showClose: true,
		});
		return Promise.reject(error);
	}
);

// 网络不通时候的提示;微信消息提醒
requestwx.interceptors.response.use(
	(response) => {
		return response;
	},
	(error) => {
		Message({
			message: "请检查网络连接",
			type: "error",
			duration: 5 * 1000,
			showClose: true,
		});
		return Promise.reject(error);
	}
);
